// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"616":"4754b44f","727":"ac640625","766":"b31f8c1b","900":"66ce658b"}[chunkId] + ".chunk.js";
};